/**
 * Keeps the product-page discount badge (#ProductSaleBadge-<section-id>)
 * in sync when the shopper switches size/variant.
 *
 * The badge markup (sections/product-template-1.liquid) carries data
 * attributes describing how it should render:
 *   data-amount-off  "true"/"false" - amount-off vs percent/text mode
 *   data-tagsale     mirrors settings.tagsale ("percent" | "txt" | mixed)
 *   data-sale-text   the configured "on sale" label
 *
 * theme.js already fires a "variantPriceChange" event on the product
 * section container whenever price/compare_at_price changes for the
 * selected variant. We listen for that same event and recompute the
 * badge text/visibility from these attributes, independent of the
 * badge text theme.js itself writes into ".product-tag-sale-number".
 */
(function () {
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function updateBadge(sectionEl, variant) {
    if (!variant) {
      return;
    }
    var badge = sectionEl.querySelector('[id^="ProductSaleBadge-"]');
    if (!badge) {
      return;
    }

    if (!(variant.compare_at_price > variant.price)) {
      badge.classList.add('hide');
      return;
    }
    badge.classList.remove('hide');

    var savings = variant.compare_at_price - variant.price;
    var percent = parseInt((savings * 100) / variant.compare_at_price, 10);
    var amountOff = badge.getAttribute('data-amount-off') === 'true';
    var tagsale = badge.getAttribute('data-tagsale');
    var saleText = badge.getAttribute('data-sale-text') || 'on sale';

    if (amountOff) {
      badge.innerHTML = '-' + formatMoney(savings);
    } else if (tagsale === 'percent') {
      badge.innerHTML = '-' + percent + '%';
    } else if (tagsale === 'txt') {
      badge.innerHTML = saleText;
    } else {
      badge.innerHTML =
        saleText + ' <span class="product-tag-sale-number">' + percent + '%</span>';
    }
  }

  function handle(evt) {
    var sectionEl = evt.target.closest
      ? evt.target.closest('[data-section-type="product"]')
      : evt.target;
    if (!sectionEl) {
      return;
    }
    updateBadge(sectionEl, evt.variant);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.jQuery) {
      jQuery(document).on('variantPriceChange variantChange', '[data-section-type="product"]', handle);
    } else {
      document.addEventListener('variantPriceChange', handle);
      document.addEventListener('variantChange', handle);
    }
  });
})();
